import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";

export function TeamMemberSkeleton({ variant = "table" }: { variant?: "table" | "card" }) {
  if (variant === "card") {
    return (
      <Card>
        <CardContent className="p-6">
          <div className="flex items-center gap-4">
            <Skeleton variant="shimmer" className="h-12 w-12 rounded-full" />
            <div className="space-y-2 flex-1">
              <Skeleton variant="shimmer" className="h-4 w-32" />
              <Skeleton variant="shimmer" className="h-3 w-24" />
            </div>
            <Skeleton variant="shimmer" className="h-9 w-20" />
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <TableBody>
      {Array.from({ length: 8 }).map((_, index) => (
        <TableRow key={index}>
          <TableCell>
            <div className="flex items-center gap-3">
              <Skeleton variant="shimmer" className="h-10 w-10 rounded-full" />
              <div className="space-y-1">
                <Skeleton variant="shimmer" className="h-4 w-32" />
                <Skeleton variant="shimmer" className="h-3 w-24" />
              </div>
            </div>
          </TableCell>
          <TableCell>
            <Skeleton variant="shimmer" className="h-4 w-20" />
          </TableCell>
          <TableCell>
            <Skeleton variant="shimmer" className="h-4 w-24" />
          </TableCell>
          <TableCell>
            <Skeleton variant="shimmer" className="h-4 w-16" />
          </TableCell>
          <TableCell>
            <Skeleton variant="shimmer" className="h-9 w-20" />
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
}

